import config from 'src/config'

const HOST = window.location.hostname.endsWith('.tablelist.com')
  ? '.tablelist.com'
  : '.tablelistpro.com'

export default {
  domain: config.NODE_ENV === 'local' ? undefined : HOST,
  sameSite: config.NODE_ENV === 'local' ? undefined : 'none',
  secure: config.NODE_ENV !== 'local',
}



// WEBPACK FOOTER //
// ./src/constants/cookieOptions.js